import { useEffect, useState } from "react";
import { getDdtsDetailsAPI, getDdtsDetailsListAPI } from "../../api/ddt.api";
import { DdtDetailsModel } from "../models/ddt-details";
import { DdtDetailsListItemModel } from "../models/ddt-details-list";
interface Props {
    setIsLoading: (loading: boolean) => void;
    ddtId: string;
    setIsLoadingOnRow?: (loading: boolean) => void;
    documentId?: string;
    ddtLineNo?: string;
}
export function useGetDdtDetails(props: Props) {
    const [ddtDetails, setDdtDetails] = useState<DdtDetailsModel>();
    const [foundRow, setFoundRow] = useState<
        DdtDetailsListItemModel | undefined
    >(undefined);

    useEffect(() => {
        const load = async () => {
            if (!props.ddtId) return;

            try {
                props.setIsLoading(true);
                const ddts = await getDdtsDetailsAPI(props.ddtId);

                setDdtDetails(ddts);
            } catch (error) {
                console.log("Error in useGetDdtDetails:", error);
            } finally {
                props.setIsLoading(false);
            }
        };
        load();
    }, [props.ddtId]);

    useEffect(() => {
        const load = async () => {
            if (
                !props.documentId ||
                !props.ddtLineNo ||
                !props.setIsLoadingOnRow
            )
                return;
            try {
                props.setIsLoadingOnRow(true);
                const rows = await getDdtsDetailsListAPI(props.documentId);
                setFoundRow(
                    rows.find((row) => row.lineObjNo === props.ddtLineNo),
                );
            } catch (error) {
                console.log("Error in useGetDdtDetails:", error);
            } finally {
                props.setIsLoadingOnRow(false);
            }
        };
        load();
    }, [props.documentId, props.ddtLineNo]);

    return { ddtDetails, foundRow };
}
